import React from 'react';
import MdsDashboardGuard from 'src/sections/dashboard/mds-dashboard/mds-dashboard-guard';
import MdsWorksheet from 'src/sections/dashboard/mds-dashboard/mds-worksheet';

/** BRK-1852: the read-only MDS worksheet (guard enforces flag + permission). */
const MdsDashboardPatient: React.FC = () => {
  return (
    <MdsDashboardGuard>
      <MdsWorksheet />
    </MdsDashboardGuard>
  );
};

export default MdsDashboardPatient;
